const stateDefault =  [];

export default (state = stateDefault, action) => {
  switch (action.type){
    case 'GET_SITUATIONS_SUCCESS':
      return action.payload ;
    default:
      return state;
  }
};
